var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2323 26H0.997972C0.636058 26 0.302035 25.8027 0.126722 25.4847C-0.0485902 25.1667 -0.0386292 24.778 0.153285 24.47L7.61868 12.47C7.80063 12.1773 8.12004 12 8.46336 12H31.675C32.5316 12 33.3159 12.47 33.7216 13.2273C34.1274 13.9847 34.0869 14.9007 33.6154 15.618L27.0631 25.552C26.8785 25.832 26.5664 26 26.2323 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99219 9C1.99219 7.346 3.33293 6 4.98047 6H22.2461C23.8936 6 25.2344 7.346 25.2344 9V10H27.2266V6.66667C27.2266 5.196 26.0352 4 24.5703 4H12.6172V2.66667C12.6172 1.196 11.4259 0 9.96094 0H2.65625C1.19133 0 0 1.196 0 2.66667V20.938L1.99219 17.736V9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2461 8H4.98047C4.43063 8 3.98438 8.448 3.98438 9V14.5333L5.92742 11.4107C6.47727 10.5273 7.42488 10 8.46215 10H23.2429V9C23.2429 8.448 22.7966 8 22.2468 8H22.2461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.f770515b60f58f0a2c963d0ea8b7e4b0.svg";
export { ForwardRef as ReactComponent };